/* eslint-disable */
import React, { useState } from 'react';

import {
  Typography,
  Button,
  FormControl,
  Container,
  Divider,
  Grid,
  Paper,
  Box,
} from '@mui/material';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import { useEffectAsync } from '../reactHelper';
import updates from '../common/util/updatesHistory';
import { usePremiumTokens } from '../common/theme/usePremiumTokens';

const useStyles = makeStyles()((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  details: {
    flexDirection: 'column',
  },
  paper: {
    padding: '6px 16px',
    textAlign: 'left'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

const UpdatesPage = () => {
  const { classes } = useStyles();
  const t = useTranslation();
  const navigate = useNavigate();
  const tokens = usePremiumTokens();

  const server = useSelector((state) => state.session.server);

  const [version, setVersion] = useState('0.1');
  const [checkVersion, setCheckVersion] = useState('0.1');
  const [newUpdate, setNewUpdate] = useState('Sistema Atualizado.');

  useEffectAsync(async () => {
    setVersion(server.version);

    const response = await fetch(`${window.location.protocol}//centralderastreamento.net.br/downloads/central_2022_version.txt`, {});
    if (response.ok) {
      const ck = await response.text();
      setCheckVersion(ck.trim());
      if (!version.trim() !== ck.trim()) {
        setNewUpdate('Nova versão disponível!');
      }
    }
  }, [server]);

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedUpdates']}>
      <Container maxWidth={false} className={classes.container}>
        {server && (
          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: tokens.radius.lg,
              backgroundColor: tokens.surface.card,
              border: `1px solid ${tokens.border.subtle}`,
            }}
          >
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, sm: 4 }} />
              <Grid size={{ xs: 12, sm: 4 }} sx={{ alignContent: 'center' }}>
                <Typography variant="h1" align="center" sx={{ color: tokens.accent.primary }}>
                  {updates[updates.length - 1].id}
                </Typography>
                <Typography
                  variant="subtitle2"
                  align="center"
                  sx={{ color: version.includes(checkVersion) ? tokens.semantic.success : tokens.semantic.error }}
                >
                  {newUpdate}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }} />

              <Grid size={{ xs: 12, sm: 2 }} />
              <Grid size={{ xs: 12, sm: 8 }}><Divider /></Grid>
              <Grid size={{ xs: 12, sm: 2 }} />

              <Grid size={{ xs: 12, sm: 4 }}>
                <Typography variant="h5" sx={{ color: tokens.accent.primary }}>
                  {t('sharedDescription')}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 4 }} />
              <Grid size={{ xs: 12, sm: 4 }} />

              <Grid size={12}>
                <Timeline position="alternate">
                  {updates.map((update, index) => {
                    return (
                      <TimelineItem key={update.id}>
                        <TimelineOppositeContent>
                          <Typography variant="body2" color="textSecondary">
                            {update.id}
                          </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot sx={{ backgroundColor: tokens.accent.primary }} />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          <Paper
                            elevation={0}
                            sx={{
                              p: 2,
                              borderRadius: tokens.radius.md,
                              backgroundColor: tokens.surface.elevated,
                              border: `1px solid ${tokens.border.default}`,
                            }}
                          >
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                              {update.items.map((item, itemIndex) => {
                                return (
                                  <li key={itemIndex}><Typography>{item.update}</Typography></li>
                                )
                              })}
                            </ul>
                          </Paper>
                        </TimelineContent>
                      </TimelineItem>
                    )
                  })}
                </Timeline>
              </Grid>
            </Grid>
          </Paper>
        )}
        <FormControl fullWidth margin="normal">
          <div className={classes.buttons}>
            <Button
              type="button"
              color="primary"
              variant="outlined"
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: tokens.radius.md,
                borderColor: tokens.border.default,
                '&:hover': {
                  borderColor: tokens.accent.primary,
                },
              }}
            >
              {t('sharedGoBack')}
            </Button>
          </div>
        </FormControl>
      </Container>
    </PageLayout>
  );
};

export default UpdatesPage;
